import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import { reducers } from './reducers'
import { middleware } from './middleware'
import { listenerMiddleware } from './listenerMiddleware'

const rootReducer = combineReducers(reducers)

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .prepend(listenerMiddleware.middleware)
      .concat(middleware),
})

setupListeners(store.dispatch)

export type AppStore = typeof store
export type AppState = ReturnType<typeof rootReducer>
export type AppReducerState = Parameters<typeof rootReducer>[0]
export type AppDispatch = typeof store.dispatch

export { store }
